export default "__VITE_ASSET__D2o2aI0g__"